import {MutationTree} from "vuex";
import {IPortalTimelineItem, IPortalTimelineWidgetState, IPortalTimelineWidgetLabels} from "@/apps/PortalTimelineWidget/models/portal-timeline-widget-state";

export default <MutationTree<IPortalTimelineWidgetState>>{
    setSelectedItemIndex(state: IPortalTimelineWidgetState, selectedItemIndex: number) {
        state.selectedItemIndex = selectedItemIndex;
    },
    setSelectedItem(state: IPortalTimelineWidgetState, index: number) {
        state.selectedItem = state.items[index];
    },
    setSelectedTopic(state: IPortalTimelineWidgetState, payload: { item: IPortalTimelineItem, index: number }) {
        state.selectedTopic = payload.item.topics[payload.index];
    },
    unsetOpenTopics(state: IPortalTimelineWidgetState) {
        state.currentlyOpenTopic = -1
        localStorage.currentlyOpenTopic = state.currentlyOpenTopic
    },
    setItems(state: IPortalTimelineWidgetState, items: IPortalTimelineItem[]) {
        state.items = items;
    },
    setLabels(state: IPortalTimelineWidgetState, labels: IPortalTimelineWidgetLabels) {
        state.labels = labels;
    },
    setCurrentlyOpenTopic(state: IPortalTimelineWidgetState, index: number) {
        state.currentlyOpenTopic = index
    }
}
